// import {showMessage} from "react-native-flash-message";

// const showError = (message) => {
//     showMessage({
//         type: 'danger',
//         icon: 'danger',
//         message
//     })
// }

// const showSuccess = (message) => {
//     showMessage({
//         type: 'success',
//         icon: 'success',
//         message
//     })
// }

// export {
//     showError, 
//     showSuccess
// }

export const nigerianStates = [
    "Abia",
    "Adamawa",
    "Akwa Ibom",
    "Anambra",
    "Bauchi",
    "Bayelsa",
    "Benue",
    "Borno",
    "Cross River",
    "Delta",
    "Ebonyi",
    "Edo",
    "Ekiti",
    "Enugu",
    "Federal Capital Territory",
    "Gombe",
    "Imo",
    "Jigawa",
    "Kaduna",
    "Kano",
    "Katsina",
    "Kebbi",
    "Kogi",
    "Kwara",
    "Lagos",
    "Nasarawa",
    "Niger",
    "Ogun",
    "Ondo",
    "Osun",
    "Oyo",
    "Plateau",
    "Rivers",
    "Sokoto",
    "Taraba",
    "Yobe",
    "Zamfara"
];
